/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DataChartBarsXyVIcon20Regular = forwardRef('DataChartBarsXyVIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M2 3.25a.75.75 0 0 1 .75.75v12c0 .69.56 1.25 1.25 1.25h14a.75.75 0 0 1 0 1.5H4A2.75 2.75 0 0 1 1.25 16V4A.75.75 0 0 1 2 3.25Z" }),
        React.createElement("path", { d: "M6 10.163a.75.75 0 0 1 .75.75v3.337a.75.75 0 0 1-1.5 0v-3.337a.75.75 0 0 1 .75-.75Z" }),
        React.createElement("path", { d: "M9.75 6.384a.75.75 0 1 0-1.5 0v7.836a.75.75 0 0 0 1.5 0V6.384Z" }),
        React.createElement("path", { d: "M15 3.25a.75.75 0 0 1 .75.75v10.22a.75.75 0 0 1-1.5 0V4a.75.75 0 0 1 .75-.75Z" }),
        React.createElement("path", { d: "M12.75 8.624a.75.75 0 0 0-1.5 0v5.596a.75.75 0 0 0 1.5 0V8.624Z" })));
});
